import { render, staticRenderFns } from "./CorrespondenceTemplatesView.vue?vue&type=template&id=7890d489&scoped=true&"
import script from "./CorrespondenceTemplatesView.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceTemplatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890d489",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle})
